export enum MonitorSegment {
  Mow = 'Mow',
  Grass = 'Grass',
  GrassOrganic = 'GrassOrganic',
  Maize = 'Maize',
}

export const MonitorSegmentTranslations: {
  [T in MonitorSegment]: string;
} = {
  Mow: 'Maai',
  Grass: 'Gras',
  GrassOrganic: 'Bio Gras',
  Maize: 'Maïs',
};

/* eslint-disable max-len */
export const MonitorScoreTranslations: {
  [T in MonitorSegment]: string;
} = {
  Mow: `Tijdens het groeiseizoen brengen we wekelijks de actuele voederwaarde en groei van de maaisnede in jouw regio in beeld.<br/><br/>Agrifirm volgt, verspreid over Nederland, de opbrengst en voederwaarde van de eerste en de tweede maaisnede.<br/><br/>De verzamelde gegevens zijn input voor de voorspelling van de drogestofopbrengst de voederwaarde en het ruw eiwit op het moment van maaien. Afhankelijk van de wensen t.a.v. snedezwaarte, gewenst ruw eiwit of voederwaarde wordt er een maaiadvies gegeven voor jouw regio.`,
  Grass: `Tijdens het weideseizoen brengen we wekelijks de actuele voederwaarde en groei van gras in jouw regio in beeld.<br/><br/>Daarvoor wordt op diverse bedrijven verdeeld over het land en gespreid per grondsoort wekelijks een vers grasmonster genomen.<br/><br/>Op basis van deze gegevens worden adviezen gegeven over rantsoensamenstelling en eventuele bijvoeding.`,
  GrassOrganic: `Tijdens het weideseizoen brengen we wekelijks de actuele voederwaarde en groei van biologisch geteeld gras in jouw regio in beeld.<br/><br/>Daarvoor wordt op diverse bedrijven verdeeld over het land en gespreid een vers grasmonster genomen.<br/><br/>Op basis van deze gegevens worden adviezen gegeven over rantsoensamenstelling en eventuele bijvoeding.`,
  Maize: `Tijdens het groeiseizoen van de snijmais brengen we wekelijks de ontwikkeling in jouw regio in beeld.<br/><br/>Agrifirm volgt tijdens het seizoen, verspreidt over heel Nederland, de groei van de snijmais. Vanaf eind augustus geven we ook wekelijks een update over de afrijping van de mais. Door middel van deze actuele adviezen helpen wij je graag om het optimale hakselmoment te bepalen.`,
};

/* eslint-enable max-len */
